module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAABGdBTUEAALGPC/xhBQAAAGlQTFRFAAAA/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////ButdgAAACJ0Uk5TAAMGBxEUFx45REhJbXh9hIWGnqKtz9jb3uLj8PLz9fb5/kzQtY0AAACOSURBVDjLY2AYlIBbSgkPkOIGK8KrBqgKrEiJAIApwu2WoaGIXwHmIwUBnIpkEP6WwalIAGES/2DxHcRNcJ9hVySL6jPsigQVUHw2BCIYGxBmQ1YkiUOVNA8jQhEXLlVKohz43cLAKQaUVxTCr4iBiVcOKUvhBOwiRCgCOlecCEUMzHzyEkQUJyys1CycAMQ7MNbjoiFAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/e5_evaluation@2x.png
// module id = oC8i
// module chunks = 0